export const configs = () => {
  if (
    window.location.hostname.includes("dev") ||
    process.env.NODE_ENV === "development"
  ) {
    return {
      BASE_URL: "https://dev-api.tripi.vn",
      APIS_URL: "https://apis.dev.tripi.vn",
    };
  }
  return {
    BASE_URL: "https://tourapi.tripi.vn/v3",
    APIS_URL: "https://apis.tripi.vn",
  };
};
